import React from "react";
import { AuthLandingEntry } from "../features/nemonto";

// Landing and Auth
export const IndexRouters = [
  {
    path: "/",
    element: <AuthLandingEntry />,
  },
];
